import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { inject, observer } from 'mobx-react'
import BasePage from '../../base/components/BasePage'
import Loader from '../../shared/components/Loader'

@inject('rating')
@observer
export default class UserBase extends Component {

  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
    rating: PropTypes.object.isRequired,
  }

  componentWillMount() {
    const { rating } = this.props
    if (!rating.length && !rating.collection.length) {
      rating.load()
    }
  }

  render() {

    const children = this.props.rating.loading
      ? <Loader>Bewertungen werden geladen...</Loader>
      : this.props.children

    return (
      <BasePage type="rating">
        {children}
      </BasePage>
    )
  }
}



// WEBPACK FOOTER //
// ./src/rating/containers/Container.js